module.exports = __webpack_public_path__ + "img/course86.bc98d551.png";